export function throttle<T extends (...args: any[]) => any>(func: T, delay: number): (...args: Parameters<T>) => void {
  let lastCall = 0;
  let timeoutId: ReturnType<typeof setTimeout> | undefined;

  return function (...args: Parameters<T>) {
    const now = Date.now();

    if (now - lastCall < delay) {
      if (!timeoutId) {
        timeoutId = setTimeout(
          () => {
            func(...args);

            lastCall = Date.now();

            timeoutId = undefined;
          },
          delay - (now - lastCall)
        );
      }

      return;
    }

    func(...args);

    lastCall = now;
  };
}
